/* eslint-disable react/destructuring-assignment */
import { Group, Paper, Space, Text, ThemeIcon } from '@mantine/core';
import {
  IconActivity,
  IconAtom,
  // IconBusinessplan,
  IconId,
  IconInfoCircle,
  IconTool,
} from '@tabler/icons-react';
import { Tabs } from 'antd';
import PageViewAudit from '../../../../../components/core/PageViewAudit/PageViewAudit';
import { UnitOfMeasureType } from '../../../../../models/core/cache.type';
import { ProposalType } from '../../../../../models/core/proposals.type';
import { Feature } from '../../../../../utils/constants.utils';
// import CommissionView from './components/ComissionView';
import GeneralView from './components/GeneralView';
import ResidueView from './components/ResidueView';
import ServiceView from './components/ServiceView';
import StatusView from './components/StatusView';
import SummaryView from './components/SummaryView';

type DataViewProps = {
  referenceData: {
    unitOfMeasures: UnitOfMeasureType[];
  };
  data: ProposalType;
  zIndex: number;
};

export default function DataView(props: DataViewProps) {
  const tabs = [
    {
      key: 'Resumo',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconInfoCircle size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Resumo
          </Text>
        </Group>
      ),
      children: <SummaryView data={props.data} />,
      forceRender: true,
    },
    {
      key: 'Geral',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconId size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Geral
          </Text>
        </Group>
      ),
      children: (
        <div>
          <Paper shadow="xs" p="md" withBorder>
            <GeneralView data={props.data} />
          </Paper>
          <Space h="lg" />

          <PageViewAudit
            idCriadoPor={props.data.idCriadoPor}
            criadoPor={props.data.criadoPor}
            dataCriacao={props.data.dataCriacao}
            idModificadoPor={props.data?.idModificadoPor || null}
            modificadoPor={props.data?.modificadoPor || null}
            dataModificacao={props.data?.dataModificacao || null}
            size="md"
          />
        </div>
      ),
      forceRender: true,
    },
    {
      key: 'Resíduos',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconAtom size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Resíduos
          </Text>
        </Group>
      ),
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <ResidueView
            data={props.data.residuos}
            referenceData={props.referenceData}
            services={props.data.servicos}
            zIndex={props.zIndex + 1}
          />
        </Paper>
      ),
      forceRender: true,
    },
    {
      key: 'Serviços',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconTool size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Serviços
          </Text>
        </Group>
      ),
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <ServiceView
            data={props.data.servicos}
            proposal={props.data}
            referenceData={props.referenceData}
            zIndex={props.zIndex + 1}
          />
        </Paper>
      ),
      forceRender: true,
    },
    // {
    //   key: 'Comissoes',
    //   label: (
    //     <Group>
    //       <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
    //         <IconBusinessplan size={18} />
    //       </ThemeIcon>
    //       <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
    //         Comissões
    //       </Text>
    //     </Group>
    //   ),
    //   children: (
    //     <Paper shadow="xs" p="md" withBorder>
    //       <CommissionView data={props.data.comissoes} />
    //     </Paper>
    //   ),
    //   forceRender: true,
    // },
    // {
    //   key: 'Eventos',
    //   label: (
    //     <Group>
    //       <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
    //         <IconCalendarEvent size={18} />
    //       </ThemeIcon>
    //       <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
    //         Eventos (Simulação)
    //       </Text>
    //     </Group>
    //   ),
    //   children: (
    //     <Paper shadow="xs" p="md" withBorder>
    //       <EventView proposal={props.data} />
    //     </Paper>
    //   ),
    //   forceRender: false,
    // },
    {
      key: 'Status',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconActivity size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Status
          </Text>
        </Group>
      ),
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <StatusView data={props.data} />
        </Paper>
      ),
      forceRender: true,
    },
  ];

  return (
    <Paper shadow="xs" p="md" withBorder>
      <Tabs
        items={tabs}
        defaultActiveKey="Geral"
        className="custom-ant-tabs-nav-list custom-ant-tabs-nav-list-7"
      />
    </Paper>
  );
}
